import React from 'react';
import { useAuth } from '../context/AuthContext';
import EmployeeHome from './employeeHome';
import ClientManagerHome from './clientManagerHome';
import EmployerHome from './employerHome';

const Home = () => {
  const { role } = useAuth();

  if (!role) {
    return <p>Loading...</p>;
  }

  switch (role.toLowerCase()) {
    case 'employee':
      return <EmployeeHome />;
    case 'client_manager':
      return <ClientManagerHome />;
    case 'employer':
      return <EmployerHome />;
    default:
      return <p>Unauthorized role</p>;
  }
};

export default Home;
